<template>
    <el-button-group class="ProductUpsell ProductUpsell__Checkbox">
            <div class="description">
            <b>{{title}}</b><br>
            <small>{{subtitle}}</small>
            </div>
    </el-button-group>
</template>

<script>

export default {
  name: 'CustomMessageText',
  data () {
    return {
      product_enabled: !!this.UpsellProduct
    }
  },
  props: ['title', 'subtitle']
}
</script>
